/** */
export type MBoolean = boolean | (() => boolean);
export type MGridSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

/** */
export const evalulateBool = function(value?: MBoolean): boolean {

    if(value === undefined) {
        return false;
    }

    return typeof value === 'function' ? value() : value;

};
